import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import { generatePath } from 'react-router-dom';
import { EVENT_ENROLLMENT_CONFIG, EVENT_ENROLLMENT_CONFIG_REVISION_PREVIEW, LIST_ENROLLMENT_CONFIG, LIST_ENROLLMENT_CONFIG_REVISION_PREVIEW, SCHEDULED_ENROLLMENT_CONFIG, SCHEDULED_ENROLLMENT_CONFIG_REVISION_PREVIEW, TRIGGER_SELECTION_ENROLLMENT_CONFIG, TRIGGER_SELECTION_REVISION_PREVIEW } from 'automation-ui-canvas/constants/AbsolutePaths';
export const getEnrollmentConfigRoute = ({
  flow,
  revisionId
}) => {
  const isRevisionPreview = revisionId !== null && revisionId !== undefined && !isNaN(revisionId);
  switch (getExistingTriggerType(flow.toHybridFlowInterface())) {
    case 'EVENT':
      return generatePath(isRevisionPreview ? EVENT_ENROLLMENT_CONFIG_REVISION_PREVIEW : EVENT_ENROLLMENT_CONFIG, {
        flowId: flow.flowId,
        revisionId
      });
    case 'SCHEDULE':
      {
        return generatePath(isRevisionPreview ? SCHEDULED_ENROLLMENT_CONFIG_REVISION_PREVIEW : SCHEDULED_ENROLLMENT_CONFIG, {
          flowId: flow.flowId,
          revisionId
        });
      }
    case 'LIST':
      return generatePath(isRevisionPreview ? LIST_ENROLLMENT_CONFIG_REVISION_PREVIEW : LIST_ENROLLMENT_CONFIG, {
        flowId: flow.flowId,
        revisionId
      });
    default:
      return generatePath(isRevisionPreview ? TRIGGER_SELECTION_REVISION_PREVIEW : TRIGGER_SELECTION_ENROLLMENT_CONFIG, {
        flowId: flow.flowId,
        revisionId
      });
  }
};